<template>
  <div class="around-my-slider">
    <div id="my-slider" :se-min="minThreshold" :se-step="step" :se-min-value="min" :se-max-value="max"
         :se-max="maxThreshold" class="slider">
      <div class="slider-touch-left">
        <span></span>
      </div>
      <div class="slider-touch-right">
        <span></span>
      </div>
      <div class="slider-line">
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>

import ZbRangeSlider from './DoubleRangeSliderLogic' //attention ! certaines valeurs du JS sont des paramètres qui dépendent des margins et paddings mis dans ce component (voir les 'TODO edited par bleu122')

export default {

  name: 'DoubleRangeSliderField',

  props: {
    minThreshold: {
      type: Number,
      default: 0
    },
    maxThreshold: {
      type: Number,
      default: 1000
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      slider : null
    }
  },

  mounted: function () {
    if (!this.slider) {
      this.slider = new ZbRangeSlider('my-slider')
    }
    this.slider.onChange = (min, max) => this.updateValues(min, max)
  },
  destroyed: function () {

  },
  methods: {
    updateValues: function (min, max) {
      this.$emit('update:min', min)
      this.$emit('update:max', max)
    }
  }

}

</script>

<style scoped>

/** ajouté par bleu122 */
.around-my-slider {
  /*todo laetitia voir si c'est possible de passer le double range en position absolute pour que avec ces margins, il passe par-dessus le scroll et qu'il soit visible !*/
  /*margin-left: -18px;*/
  /*margin-right: -18px;*/
}

.slider {
  display: block;
  position: relative;
  height: 36px;
  width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.slider .slider-touch-left,
.slider .slider-touch-right {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  display: block;
  position: absolute;
  height: 34px;
  width: 34px;
  padding: 6px;
  z-index: 2;
  cursor: pointer;
}

.slider .slider-touch-left span,
.slider .slider-touch-right span {
  display: block;
  width: 100%;
  height: 100%;
  background: var(--main-red);
  border: 1px solid var(--main-red-dark);
  border-radius: 50%;
}

.slider .slider-line {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: calc(100% - 36px);
  left: 18px;
  top: 14px;
  height: 6px;
  border-radius: 6px;
  background: var(--main-grey);
  z-index: 0;
  overflow: hidden;
}

.slider .slider-line span {
  display: block;
  height: 100%;
  width: 0%;
  background: var(--main-red-dark);
}

</style>



// WEBPACK FOOTER //
// src/views/venteLot/DoubleRangeSlider.vue